import { Link } from 'react-router'
import { CategoryChip } from '../components/CategoryChip'
import { DayCell, OwnerCell, PersonName, PlainText, RelativeTime } from '../list/commonCells'
import type { ColumnRender } from '../list/RecordListPage'
import { shortDay } from '../record/format'
import { AgreementStatusBadge } from './AgreementStatusBadge'
import { Duration, NextDeadline } from './AgreementCells'
import { agreementHref } from './format'
import type { Agreement } from './types'

const STATUS = { actief: 'Actief', gepauzeerd: 'Gepauzeerd', beeindigd: 'Beëindigd' } as const

/** What Afspraken shows per column of its register (design §4.6). */
export function agreementColumns(): Record<string, ColumnRender<Agreement>> {
  return {
    title: {
      header: 'Afspraak',
      cell: (row) => (
        <div className="flex flex-col gap-1">
          <Link to={agreementHref(row)} className="font-medium underline-offset-2 hover:underline">
            {row.title}
          </Link>
          <span className="flex flex-wrap items-center gap-1">
            {row.category ? <CategoryChip category={row.category} /> : null}
            <AgreementStatusBadge agreement={row} />
          </span>
        </div>
      ),
    },
    category: { header: 'Soort', cell: (row) => (row.category ? <CategoryChip category={row.category} /> : <PlainText value={null} />) },
    party: {
      header: 'Relatie',
      cell: (row) => (
        <div className="flex flex-col">
          {row.organisation ? <span>{row.organisation.name}</span> : null}
          {row.person ? <PersonName name={row.person.name} /> : null}
        </div>
      ),
    },
    owner: { header: 'Eigenaar', cell: (row) => <OwnerCell owner={row.owner ? { id: row.owner.id, full_name: row.owner.name } : null} /> },
    status: { header: 'Status', cell: (row) => <PlainText value={STATUS[row.status]} /> },
    schedule: { header: 'Opvolging', cell: (row) => <PlainText value={row.rhythm_text} /> },
    next_due_on: { header: 'Volgende deadline', cell: (row) => <NextDeadline agreement={row} /> },
    last_done_on: {
      header: 'Laatst gedaan',
      cell: (row) =>
        row.last_done_on ? (
          <span className="text-muted-foreground">{`${shortDay(row.last_done_on)}${row.last_done_via ? ` (${row.last_done_via === 'contact' ? 'contact' : 'taak'})` : ''}`}</span>
        ) : (
          <PlainText value={null} />
        ),
    },
    starts_on: { header: 'Looptijd', cell: (row) => <Duration agreement={row} /> },
    ends_on: { header: 'Einddatum', cell: (row) => <DayCell day={row.ends_on} /> },
    created_at: { header: 'Aangemaakt', cell: (row) => <RelativeTime iso={row.created_at} /> },
    created_by: { header: 'Aangemaakt door', cell: (row) => (row.created_by ? <PersonName name={row.created_by.name} /> : <PlainText value={null} />) },
  }
}
